import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getLatestActivityBase } from 'lib/selectors/getLatestActivityBase';

// use most recent activity start to drive "latest" set
// Use base activity to avoid circular dependency
const getLatestActivitySetRef = createSelector(
  [getLatestActivityBase],
  (latestActivity) => {
    return _get(latestActivity, 'activitySetRef', null);
  }
);

export { getLatestActivitySetRef };
